module.exports = __webpack_public_path__ + "static/media/check-accept-gray.7f669f01.svg";